import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=cd1339de&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=cd1339de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1339de",
  null
  
)

export default component.exports